import mqtt from 'mqtt'
import { MqttBroadcast } from '../models/app/MqttBroadcast'
import { MqttMsg } from '../models/app/MqttMsg'
import { MqttMsgType } from '../models/app/MqttMsgType'
import { appConfig, OFFLINE, ONLINE } from '../models/constants'
import { rootStore } from '../StApp'
import AppCrypto from './CryptoService'
import { delay } from './HelperService'
import IMChatService from './IMChatService'
import Logger from './Logger'
import MqttMsgHandlerService from './MqttMsgHandlerService'

class MqttService {

    private client!: mqtt.MqttClient

    connect() {

        if(this.client){
            if(this.client.connected)
             return
        }

        if (rootStore.mainStore.uid == null)
            return

        console.log('Going to cconnect to client')
        this.client = mqtt.connect(appConfig.MQTT_URL,
            {
                will: {
                    topic: this.getLastWillTopic(),
                    payload: JSON.stringify(this.createStatusMsg(OFFLINE)),
                    qos: 1,
                    retain: true,
                }, keepalive: 10
            })
        this.client.on('connect', () => {
            console.log('Connected to client')
            this.makeDefaultSubscriptions()
            this.updateStatus(ONLINE)
        })

        this.handleMessages()

    }

    async disconnect() {
        this.updateStatus(OFFLINE)
        // Logger.debug('Calling Disconnect')
        // await delay(5000)
        // Logger.debug('Client Disconnected')
        this.client.end()
    }

    publish(topic: string, msg: string, qos: mqtt.QoS = 1, retain = false) {

        this.client.publish(topic, msg, { qos: qos, retain: retain })

    }

    subscribe(topic: string) {

        this.client.subscribe(topic)

    }

    unsubscribe(topic: string) {
        this.client.unsubscribe(topic)
    }

    private handleMessages() {

        this.client.on('message', (topic, payload, packet) => {
            // if(topic.includes(rootStore.mainStore.uid!))
            MqttMsgHandlerService.handleMqttMsg(payload.toString())
        })

    }

    private makeDefaultSubscriptions() {

        this.client.subscribe(`${appConfig.MQTT_BASE}/${appConfig.MQTT_PRIVATE}/${rootStore.mainStore.uid}/${appConfig.MQTT_CHAT}`)
    }

    updateStatus(status: string) {
        const mqttMsg = this.createStatusMsg(status)

        this.publish(
            `${appConfig.MQTT_BASE}/${appConfig.MQTT_PUBLIC}/${rootStore.mainStore.uid}/${appConfig.MQTT_STATUS}`,
            JSON.stringify(mqttMsg), 1, true)
    }

    private getLastWillTopic() {
        return `${appConfig.MQTT_BASE}/${appConfig.MQTT_PUBLIC}/${rootStore.mainStore.uid}/${appConfig.MQTT_STATUS}`
    }

    private createStatusMsg(status: string) {

        const mqttStatus: MqttBroadcast = {
            msg: status,
            postByUid: rootStore.mainStore.uid!,
            sign: AppCrypto.signAnyMessage(status)
        }

        const mqttMsg: MqttMsg<MqttBroadcast> = {
            data: mqttStatus,
            type: MqttMsgType.STATUS_UPDATE
        }

        return mqttMsg

    }
}

export default new MqttService()